import React from 'react';
import InterviewList from '../components/interviews/InterviewList';

const InterviewsPage = () => {
    return (
        <div>
            <InterviewList />
        </div>
    );
};

export default InterviewsPage;